import Head from 'next/head';
import type {JobDetail as JB} from '@jobseeker/common-core/lib/stateModels/job/jobdetail.models';
import moment from 'moment';

const JobPostingJsonLd = ({jobInfo}: {jobInfo: JB}) => {
  if (!jobInfo?.id) return null;

  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'JobPosting',
    title: jobInfo?.title,
    description: jobInfo?.introText,
    hiringOrganization: {
      name: jobInfo?.companyData?.companyName || '',
      sameAs: jobInfo?.companyData?.companyName || '',
      logo: jobInfo?.recruiter?.centralizedCompanyId
        ? `${process.env.NEXT_PUBLIC_S3_COMPANY_LOGO_BUCKET}${jobInfo?.recruiter?.centralizedCompanyId}.webp`
        : '',
    },
    industry: jobInfo?.categoryId,
    skills: jobInfo?.tags?.map(tag => tag.name) || [],
    experienceRequirements: {
      occupational: {
        minimumMonthsOfExperience: jobInfo?.min * 12,
      },
      educational: {
        credentialCategory: 'bachelor degree',
      },
    },
    employmentType: 'FULL_TIME',
    datePosted: moment(jobInfo?.createdTime)
      .format('DD-MM-YYYY')
      .toString(),
    validThrough: moment(jobInfo?.createdTime)
      .add(3, 'M')
      .format('DD-MM-YYYY')
      .toString(),
    jobLocation: jobInfo?.locations?.map(loc => ({
      '@type': 'Place',
      address: {
        '@type': 'PostalAddress',
        addressLocality: loc.name,
        addressCountry: 'IN',
      },
    })),
    applicantLocationRequirements: 'India',
  };

  return (
    <Head>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{__html: JSON.stringify(jsonLd)}}
      />
    </Head>
  );
};

export default JobPostingJsonLd;
